import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { subjectsOf } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";

export const CourseMetaForm = ({ title, setTitle, subject, setSubject, disabled }) => {
  const { user } = useAuth();
  return (
    <div className="grid gap-3 sm:grid-cols-[1.6fr_1fr]">
      <div>
        <label className="eyebrow mb-2 block">Titre du cours (facultatif)</label>
        <Input data-testid="course-title-input" disabled={disabled} value={title} onChange={(e) => setTitle(e.target.value)}
          placeholder="Ex. : La Révolution française" className="h-11 rounded-xl bg-card" maxLength={200} />
      </div>
      <div>
        <label className="eyebrow mb-2 block">Matière</label>
        <Select value={subject} onValueChange={setSubject} disabled={disabled}>
          <SelectTrigger data-testid="course-subject-select" className="h-11 rounded-xl bg-card"><SelectValue /></SelectTrigger>
          <SelectContent>
            {subjectsOf(user).map((s) => <SelectItem key={s} value={s} data-testid={`subject-option-${s}`}>{s === "Autre" ? "Autre / détecter automatiquement" : s}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
